import React from 'react';

interface SymbolExchangeInformationProps {
  className?: string;
  exchange: string;
  otcTier?: string | null;
  symbol: string;
}

const SymbolExchangeInformation: React.FC<SymbolExchangeInformationProps> = ({
  className = '',
  exchange,
  otcTier,
  symbol,
}) => {
  let otcExchangeTicker: string | null = null;
  if (exchange === 'OTC') {
    otcExchangeTicker = exchange + otcTier;
  }

  const exchangeBlock = exchange === 'OTC' ? otcExchangeTicker : exchange;

  return (
    <div className={`quote-exchange-information flex items-center font-semibold ${className}`}>
      <span className="text-bzgray-900 py-0.5 px-2.5 rounded-full border border-bzblue-400 mr-2">{symbol}</span>
      <span className="text-bzgray-600">{exchange ? exchangeBlock : ''}</span>
    </div>
  );
};

export default SymbolExchangeInformation;
